import { ReactNode } from "react";
import DashboardSidebar from "./DashboardSidebar";
import MobileHeader from "./MobileHeader";

type TabType = "dashboard" | "thumbnails" | "analytics" | "settings" | "billing";

interface DashboardLayoutProps {
  activeTab: TabType;
  generationsLeft?: number;
  children: ReactNode;
}

const DashboardLayout = ({ activeTab, generationsLeft, children }: DashboardLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex">
      {/* Desktop sidebar - hidden on mobile */}
      <DashboardSidebar activeTab={activeTab} generationsLeft={generationsLeft} />

      {/* Mobile header - hidden on desktop */}
      <MobileHeader generationsLeft={generationsLeft} />

      {/* Main content with top padding on mobile for fixed header */}
      <main className="flex-1 overflow-auto pt-14 lg:pt-0">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
